
import './Tasks.css';
import AddTask from './AddTask.js';
import Task from './Task.js';
import refresh from '../../assets/images/refresh.svg'
import React, {useState} from "react";

function Tasks(props) {
    const [showAddTask, setShowAddTask] = useState(false)
    const [sortBy, setSortBy] = useState('urgency')
    const [filterBy, setFilterBy] = useState('allTasks')
    const [showInProgress, setShowInProgress] = useState(true)
    const [showNotStarted, setShowNotStarted] = useState(true)
    const [showCompleted, setShowCompleted] = useState(true)
    
    let tasks = props.userProfile.tasks
    if (tasks === null) {
        tasks=[]
    }

    function refreshTasks() {
        console.log("refreshing")
        // TODO: add actual refreshing
    }

    function sortTasks( a, b) {
        if (sortBy === 'urgency') {
            if ( a.urgency < b.urgency ){
                return 1;
              }
              if ( a.urgency > b.urgency ){
                return -1;
              }
              return 0;
        } else if (sortBy==="project") {
            if ( a.goalTag < b.goalTag ){
                return -1;
              }
              if ( a.goalTag > b.goalTag ){
                return 1;
              }
              return 0;

        } else if (sortBy==="taskType"){
            if ( a.category < b.category ){
                return -1;
              }
              if ( a.category > b.category ){
                return 1;
              }
              return 0;
        }
    }

    function filterGlowTasks(a) {
        if (filterBy === "allTasks") 
        {
            return true
        }
        if (filterBy === "glow") 
        {
            if (a.glowTask) return true
            else return false
        }
        if (filterBy === "power") 
        {
            if (!a.glowTask) return true
            else return false
        }
    }

    return (
        <div className="taskBody">
            {showAddTask && 
            <AddTask tasks={tasks} setTasks={props.setTasks} userProfile={props.userProfile} setUserProfile={props.setUserProfile} setShowAddTask={setShowAddTask}/>}
            <p className="taskHeaderText centerTaskHeaderText"> TASKS FOR SPRINT CYCLE</p>
            <img onClick={() => refreshTasks()} className="refreshIcon" src={refresh} alt="arrows in a circle indicating reload" />
            <div className="taskHeader">
                <p onClick={() => setShowAddTask(true)} className="addTaskButton actualAddTask"> add task</p>
                <div className="taskFilterRow">
                    <p className="sortByText"> sort by: </p>
                    <p onClick={() => setSortBy('urgency')} className={sortBy === 'urgency' ? "addTaskButton activeSortBy" : "addTaskButton"}> urgency</p>
                    <p onClick={() => setSortBy('project')} className={sortBy === 'project' ? "addTaskButton activeSortBy" : "addTaskButton"}> project</p>
                    <p onClick={() => setSortBy('taskType')} className={sortBy === 'taskType' ? "addTaskButton activeSortBy" : "addTaskButton"}> task type</p>
                </div>
                <div className="taskFilterRow">
                    <p onClick={() => setFilterBy('allTasks')} className={filterBy === 'allTasks' ? "addTaskButton activeSortBy" : "addTaskButton"}> all tasks</p>
                    <p onClick={() => setFilterBy('glow')} className={filterBy === 'glow' ? "addTaskButton activeSortBy" : "addTaskButton"}> glow</p>
                    <p onClick={() => setFilterBy('power')} className={filterBy === 'power' ? "addTaskButton activeSortBy" : "addTaskButton"}> power</p>
                </div>
            </div>
            <div className="taskSection">
                <div className="taskSectionHeaderRow">
                <p className={!showInProgress ? "expandTriangle" : "expandTriangle expandTriangleFlipped"} onClick={() => setShowInProgress(!showInProgress)}> ^ </p>
                <p className="taskHeaderText"> IN PROGRESS: </p>
                </div>
                {showInProgress &&
                <div className="taskRows">
                    {tasks.filter((task) => task.status==="inProgress").filter(filterGlowTasks).sort(sortTasks).map((task, index) => (
                        <Task key={index} index={tasks.indexOf(task)} userProfile={props.userProfile} setUserProfile={props.setUserProfile} task={task} tasks={tasks} setShowAddTask={setShowAddTask}/>
                ))}
                </div>
                }
            </div>
            <div className="taskSection">
            <div className="taskSectionHeaderRow">
                <p className={!showNotStarted ? "expandTriangle" : "expandTriangle expandTriangleFlipped"} onClick={() => setShowNotStarted(!showNotStarted)}> ^ </p>
                <p className="taskHeaderText"> NOT STARTED: </p>
                </div>
                {showNotStarted &&
                <div className="taskRows">
                    {tasks.filter((task) => task.status===null || task.status==="notStarted").filter(filterGlowTasks).sort(sortTasks).map((task, index) => (
                        <Task key={index} index={tasks.indexOf(task)} userProfile={props.userProfile} setUserProfile={props.setUserProfile} task={task} tasks={tasks} setShowAddTask={setShowAddTask}/>
                ))}
                                </div>
}
            </div>
            <div className="taskSection">
            <div className="taskSectionHeaderRow">
                <p className={!showCompleted ? "expandTriangle" : "expandTriangle expandTriangleFlipped"} onClick={() => setShowCompleted(!showCompleted)}> ^ </p>
                <p className="taskHeaderText"> COMPLETED: </p>
                </div>
                {showCompleted &&
                <div className="taskRows">
                    {tasks.filter((task) => task.status==="completed").filter(filterGlowTasks).sort(sortTasks).map((task, index) => (
                        <Task key={index} index={tasks.indexOf(task)} userProfile={props.userProfile} setUserProfile={props.setUserProfile} task={task} tasks={tasks} setShowAddTask={setShowAddTask}/>
                ))}
                </div>
        }
            </div>
        </div>
    )
}

export default Tasks;